import * as api from "../api/client";
import { usePolledResource } from "../hooks/usePolling";
import { useAuth } from "../hooks/AuthContext";

const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:8787";

export function Settings() {
  const { data: info, loading } = usePolledResource(api.getGeneratorInfo, null);
  const { logout } = useAuth();

  return (
    <>
      <div className="topbar">
        <div className="page-title-group">
          <h1>Settings</h1>
          <p>Deployment configuration. Secrets are never shown here — they are managed as Cloudflare secrets.</p>
        </div>
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Connection</h2>
        </div>
        <div className="field-grid">
          <div>
            <span className="field-label">Dashboard is talking to</span>
            <div className="field-value mono">{API_BASE_URL}</div>
          </div>
          <div>
            <span className="field-label">Generator version</span>
            <div className="field-value mono">{loading ? "…" : info?.generatorVersion ?? "—"}</div>
          </div>
          <div>
            <span className="field-label">Protocol version</span>
            <div className="field-value mono">{loading ? "…" : info?.protocolVersion ?? "—"}</div>
          </div>
        </div>
        <p className="form-hint">
          Set with <code className="mono">VITE_API_BASE_URL</code> at build time. See README for deployment
          instructions.
        </p>
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Heartbeat intervals</h2>
        </div>
        <div className="field-grid">
          <div>
            <span className="field-label">Normal</span>
            <div className="field-value mono">{loading ? "…" : `${info?.defaults.heartbeatNormalSeconds ?? "—"}s`}</div>
          </div>
          <div>
            <span className="field-label">Degraded</span>
            <div className="field-value mono">{loading ? "…" : `${info?.defaults.heartbeatDegradedSeconds ?? "—"}s`}</div>
          </div>
        </div>
        <p className="form-hint">
          These are fixed by the deployment (10 minutes normal / 30 seconds degraded, per spec) and are set as
          Worker environment variables, not from this page.
        </p>
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Secrets</h2>
        </div>
        <p className="muted" style={{ marginBottom: "var(--space-3)" }}>
          The administrator secret, master encryption key, and session signing secret exist only as Cloudflare
          Worker secrets. They cannot be viewed, exported, or changed from this dashboard — rotate them with{" "}
          <code className="mono">wrangler secret put</code> from the command line.
        </p>
      </div>

      <div className="panel">
        <div className="panel-header">
          <h2>Session</h2>
        </div>
        <button type="button" className="btn btn-danger" onClick={() => logout()}>
          Log out of this session
        </button>
      </div>
    </>
  );
}
